<template>
  <div>
    <Header v-bind:HeaderCheck = "HeaderCheck"></Header>
    <div id="content" style="background-color: white">

      <div id="map" class="map">
      </div>
      <div class="container" style="width: 100%;background-color: white">
        <section class="one-fifth" style="top: -20px">
          <div class="part2-title">
            <p style="font-size: 32px;line-height: 45px">联系我们</p>
            <div class="horizontal-line" style="margin-top: 9px;margin-bottom: 9px"></div>
            <p style="font-size: 20px;line-height: 28px">contact us</p>
          </div>
        </section>
        <section class="three-fourth" style="top: -20px">
          <div class="part2-address">
            <div>
              <img src="static/img/contact/dingwei.png">
              <p>深圳市南山区南光路东华创业园5栋206</p>
            </div>
            <div style="margin-top: 35px">
              <img src="static/img/contact/email.png">
              <p>chenyuxia@cloudhearing.cn</p>
            </div>
          </div>
        </section>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../common/Header'
import Footer from '../common/Footer'
import AMap from 'AMap'

const HeaderCheck = {
  tip1: '',
  tip2: '',
  tip3: '',
  tip4: '',
  tip5: 'current'
}
export default {
  name: 'Contact',
  components: {Footer, Header},
  data: function () {
    return {
      HeaderCheck: HeaderCheck
    }
  },
  mounted () {
    this.GaodeMap()
  },
  methods: {
    GaodeMap () {
      var map = new AMap.Map('map', {
        center: [113.927918, 22.52207], // [纬度，经度]
        resizeEnable: true,
        zoom: 17,
        lang: 'zh_cn'
      })
      // 创建一个 Marker 实例：（标记点）
      var marker = new AMap.Marker({
        position: new AMap.LngLat(113.927918, 22.52207)// 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
      })
      AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], function () {
        map.addControl(new AMap.ToolBar())
        map.addControl(new AMap.Scale())
      })
      map.add(marker)
    }
  },
  activated () {
    // this.$router.go(0)
    window.location.reload()
  },
  inject: ['reload'],
  watch: {
    // 检测路由参数发生改变时，刷新当前页面 调用
    '$route': function () {
      this.reload()
    }
  }
}
</script>

<style scoped>
.map {
  height: 500px;
  padding: 0 0 0 0;
  position: relative;
  width: 100%;
  margin-bottom: 40px;
  margin-top: 0;
  float: left;
}
.part2-title {
  margin-left: 30%;
  margin-top: 60px;
  width: 50%;
  text-align: center;
}
.part2-title p{
  margin: 0;
  color: #808180;
}
.part2-address{
  margin-left: 10%;
  margin-top: 50px;
  margin-bottom: 50px;
}
.part2-address img{
  width: 56px;
  height: 56px;
  margin-right: 32px;
  float: left;
}
.part2-address p{
  font-size: 24px;
  line-height: 56px;
  color: #808180;
}
</style>



// WEBPACK FOOTER //
// src/components/view/Contact.vue